import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import React, { useEffect, useState } from "react";
import { FieldRenderProps } from "react-final-form";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { MultipleSelectOptions } from "../..";
import Chip from "@material-ui/core/Chip";
import { HighlightOffOutlined } from "@material-ui/icons";
import FormHelperText from "@material-ui/core/FormHelperText";

export interface MultipleSelectProps extends FieldRenderProps<any> {
  options: MultipleSelectOptions;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chips: {
      display: "flex",
      flexWrap: "wrap"
    },
    chip: {
      margin: 2,
      height: 25
    },
    input: {
      width: "100%",
      minHeight: "35px"
    },
    error: {
      marginLeft: 15,
      height: "25px"
    },
    outlined: {
      padding: "3px 35px 3px 3px"
    },
    container: {
      paddingTop: "5px"
    }
  })
);

const MenuProps = {
  PaperProps: {
    style: {
      width: 250
    }
  },
  getContentAnchorEl: null
};
export const MultipleSelect = ({
  input: { name, onChange, value, ...restInput },
  meta,
  readOnly,
  options,
  ...rest
}: MultipleSelectProps) => {
  const classes = useStyles();
  const [selected, setSelected] = useState<any[]>([]);

  useEffect(() => {
    if (value && Array.isArray(value) && value.length) {
      setSelected(value);
    } else {
      setSelected([]);
    }
  }, [value]);

  const findLabel = (value: string | number | string[] | undefined) => {
    const option = options.find((element: any) => element.value === value);
    return option ? option.label : "";
  };

  const handleDelete = (v: string | number | string[] | undefined) => (
    event: any
  ) => {
    onChange(selected.filter(value => value != v));
  };

  const handleChange = (event: any) => {
    onChange(event.target.value);
  };

  return (
    <div className={classes.container}>
      <Select
        {...rest}
        multiple={true}
        placeholder={name}
        error={meta.error}
        value={Array.isArray(selected) ? selected : []}
        onChange={handleChange}
        classes={{
          outlined: classes.outlined
        }}
        input={
          <OutlinedInput
            className={classes.input}
            name={name}
            labelWidth={40}
            notched={false}
            id="select-multiple-chip"
          />
        }
        MenuProps={MenuProps}
        variant="outlined"
        margin="dense"
        renderValue={selected => (
          <div className={classes.chips}>
            {(selected as string[]).map((v, index) => (
              <Chip
                key={findLabel(v) + index + v}
                label={findLabel(v)}
                className={classes.chip}
                disabled={readOnly}
                onDelete={handleDelete(v)}
                deleteIcon={readOnly ? <></> : <HighlightOffOutlined />}
                onMouseDown={event => {
                  event.stopPropagation();
                }}
              />
            ))}
          </div>
        )}
      >
        {options.map((option: any) => (
          <MenuItem key={option.label} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText error={true} className={classes.error}>
        {meta.error}
      </FormHelperText>
    </div>
  );
};
